import { memo } from 'react';
import styled from 'styled-components';

const Row = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 12px;
	margin-bottom: 4px;
`;

const Dot = styled.span`
	width: 10px;
	height: 10px;
	border-radius: 2px;
	flex-shrink: 0;
	background: ${({ $color }) => $color || '#888'};
`;

const NoData = styled.p`
	font-size: 11px;
	color: ${({ theme }) => theme.colors.textAccent};
	opacity: 0.6;
`;

const ClassCard = styled.div`
	background: rgba(152, 152, 152, 0.05);
	border: 1px solid ${({ theme }) => theme.colors.border};
	border-radius: 6px;
	padding: 8px 10px;
	margin-bottom: 6px;
`;

const ClassTitle = styled.div`
	font-size: 11px;
	font-weight: 600;
	text-transform: capitalize;
	color: ${({ theme }) => theme.colors.textColor};
`;

const StatsGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 4px 12px;
`;

const StatItem = styled.div`
	display: flex;
	justify-content: space-between;
	font-size: 11px;
`;

const StatLabel = styled.span`
	color: ${({ theme }) => theme.colors.textAccent};
	opacity: 0.8;
`;

const StatValue = styled.span`
	font-weight: 600;
	color: ${({ theme }) => theme.colors.textColor};
`;

const DEFAULT_COLORS = [
	'#20AC6B',
	'#60a5fa',
	'#fbbf24',
	'#f87171',
	'#a78bfa',
	'#34d399',
	'#fb923c',
	'#e879f9',
];

const DetectionsSection = memo(({ analysis }) => {
	const perClass = analysis?.statistics?.per_class;

	if (!perClass || Object.keys(perClass).length === 0) {
		return <NoData>No detection data available</NoData>;
	}

	return (
		<>
			{perClass &&
				Object.entries(perClass).map(([className, classStats], i) => (
					<ClassCard key={className}>
						<Row>
							<Dot $color={DEFAULT_COLORS[i % DEFAULT_COLORS.length]} />
							{/* TODO: Restore {className} when backend returns proper class names instead of generic 'object' */}
							{/*<ClassTitle>{className}</ClassTitle>*/}
							<ClassTitle>Reindeer</ClassTitle>
						</Row>
						<StatsGrid>
							<StatItem>
								<StatLabel>Total</StatLabel>
								<StatValue>{classStats.total_count ?? '—'}</StatValue>
							</StatItem>
							<StatItem>
								<StatLabel>Unique</StatLabel>
								<StatValue>{classStats.unique_count ?? '—'}</StatValue>
							</StatItem>
							<StatItem>
								<StatLabel>Avg/Frame</StatLabel>
								<StatValue>{classStats.average_count_per_frame ?? '—'}</StatValue>
							</StatItem>
							<StatItem>
								<StatLabel>Max Simul.</StatLabel>
								<StatValue>{classStats.max_simultaneous_count ?? '—'}</StatValue>
							</StatItem>
						</StatsGrid>
					</ClassCard>
				))}
		</>
	);
});

DetectionsSection.displayName = 'DetectionsSection';

export default DetectionsSection;
